import IconButton from "@pathwright/ui/src/components/button/IconButton"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import ProgressCircle from "@pathwright/ui/src/components/progress/ProgressCircle"
import React from "react"
import { VelocityTransitionGroup } from "velocity-react"
import "./Analytics.css"

const hasnt = function (n) {
  if (n > 1) {
    return "haven't"
  } else {
    return "hasn't"
  }
}

const AnalyticsStat = function ({ icon, title, progress, children }) {
  const infoTransition = {
    animation: {
      opacity: 1,
      translateY: "-5px",
      duration: 600
    },
    delay: 200
  }

  return (
    <div className="AnalyticsStat">
      <ProgressCircle
        className="AnalyticsStat__graph"
        progress={progress}
        strokeColor="#666"
        strokeWidth={3}
        size={150}
      >
        <div className="AnalyticsStat__perc">
          <Pathicon icon={icon} />
          {progress != null ? (
            <h4>
              {Math.floor(progress * 100)}
              <span>%</span>
            </h4>
          ) : undefined}
          <h6>{title}</h6>
        </div>
      </ProgressCircle>
      <VelocityTransitionGroup enter={infoTransition} runOnMount={true}>
        <div className="AnalyticsStat__info">{children}</div>
      </VelocityTransitionGroup>
    </div>
  )
}

class Analytics extends React.Component {
  state = {
    complete: null,
    incomplete: null,
    reached: null,
    progress: 0,
    completion: 0,
    avg_score: 0
  }

  componentDidMount() {
    return this.handleAnalytics(this.props.analytics)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    return this.handleAnalytics(nextProps.analytics)
  }

  handleAnalytics = (analytics) => {
    if (
      (analytics != null ? analytics.complete : undefined) == null ||
      this.state.complete != null
    ) {
      return
    }

    const { next_count, complete, avg_score, incomplete } = analytics
    const { point_total, display_type } = this.props

    const reached =
      display_type !== "path" ? next_count + complete : complete + incomplete
    const progress = reached / (complete + incomplete)
    const completion = complete / reached || 0 // 0 / 0 //=> NaN, so we prefer 0 over NaN :)

    return this.setState({ loaded: true }, () => {
      return _.defer(() => {
        // wait a tick so animation can happen on 2nd render
        return this.setState({
          complete,
          incomplete,
          avg_score,
          reached,
          progress,
          completion
        })
      })
    })
  }

  render() {
    const {
      item_name,
      analytics,
      point_total,
      display_type,
      modal_launched_from_url,
      isLoading
    } = this.props
    const {
      loaded,
      complete,
      incomplete,
      reached,
      progress,
      completion,
      avg_score
    } = this.state

    return (
      <div className="Analytics">
        <IconButton
          icon="x"
          className="Analytics__close"
          to={modal_launched_from_url}
        />
        <header>
          {isLoading ? (
            <h2>Loading...</h2>
          ) : display_type === "path" ? (
            <h2>How's everyone doing?</h2>
          ) : (
            <h2>
              How's everyone doing on <strong>{item_name}</strong>?
            </h2>
          )}
        </header>
        {loaded ? (
          <section>
            <AnalyticsStat
              icon="seal-check"
              title="Completion"
              progress={completion}
            >
              {complete != null && complete > 0 ? (
                display_type === "path" ? (
                  <p>{complete} completed.</p>
                ) : (
                  <p>
                    Of the {reached} that reached this {display_type},{" "}
                    {complete} completed.
                  </p>
                )
              ) : undefined}
            </AnalyticsStat>
            {point_total ? (
              <AnalyticsStat icon="award" title="Score" progress={avg_score}>
                {complete != null ? (
                  <p>
                    {complete} averaged {Math.round(avg_score * point_total)}/
                    {point_total} points.
                  </p>
                ) : undefined}
              </AnalyticsStat>
            ) : undefined}
          </section>
        ) : (
          <LoadingCircle />
        )}
      </div>
    )
  }
}

// {
//   if display_type isnt "path"
//     <AnalyticsStat
//       icon="tracks"
//       title="Progress"
//       progress={progress}>
//       {
//         if complete? and reached > 0
//             <p>{reached} reached this {display_type}.</p>
//       }
//       {
//         if complete?
//           not_reached = incomplete + complete - reached
//           if not_reached > 0
//             <p>{not_reached} {hasnt(not_reached)} reached this {display_type}.</p>
//       }
//     </AnalyticsStat>
// }

Analytics.displayName = "Analytics"

export default Analytics
